import load from './load.js';
import parseSRT from './parse-srt.js';

const noop = () => {};

export default function SRTProvider() {
  /** @type {{ [key: string]: SRTItem[]? }} */
  let cache = {};
  let isResolving = false;

  return {
    resolveFor,
    reset,
  };

  /**
   *
   * @param {Subtitle} subtitle
   * @param {(items: SRTItem[]) => void} onComplete
   * @param {(error: Error) => void} onError
   * @returns {VoidFunction} cancel fn
   */
  function resolveFor(subtitle, onComplete, onError) {
    if (isResolving) {
      onError(new Error("Already resolving subtitles, consider cancelling previous request"));
      return noop;
    }

    const cached = cache[subtitle.url];

    if (cached) {
      onComplete(cached);
      return noop;
    }

    isResolving = true;
    let cancelParse;

    let cancelLoad = load(subtitle.url, (error, response) => {
      cancelLoad = undefined;

      if (error !== null) {
        isResolving = false;
        onError(error);
        return;
      }

      if (!response) {
        isResolving = false;
        onError(new Error("Empty .srt"));
        return;
      }

      cancelParse = parseSRT(response, (srtItems) => {
        cache[subtitle.url] = srtItems;
        isResolving = false;
        onComplete(srtItems);
      });
    });

    return () => {
      cancelLoad?.();
      cancelParse?.();
      isResolving = false;
    };
  }

  function reset() {
    cache = {};
  }
}
